import React from "react";

const ModalFooterLeft = ({ children }) => {
    return <div className="Modal2-footer--left">{children}</div>;
};
export default ModalFooterLeft;
